import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "ms_khach_du_lich";

// moduleApi.create = (dataForm) => {
//   let api = {
//     module: moduleName,
//     type: "create",
//     value: dataForm
//   };
//   return ApiService(api);
// };

// moduleApi.update = (dataForm) => {
//   let api = {
//     module: moduleName,
//     type: "partialUpdate",
//     value: dataForm
//   };
//   return ApiService(api);
// };

moduleApi.list = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter
  };
  return ApiService(api);
};

// moduleApi.delete = (id) => {
//   let api = {
//     module: moduleName,
//     type: "delete",
//     value: { id: id }
//   };
//   return ApiService(api);
// };

moduleApi.findById = (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: { id: id }
  };
  return ApiService(api);
};

moduleApi.registerMsKhachDuLich = (personInfos) => {
  let api = {
    module: moduleName,
    type: "register_ms_khachdulich",
    value: {
      PersonInfos: personInfos
    },
    params: {
      // PersonInfos: personInfos
    },
    message: {
      success: "", //string | null | comment
      error: "",  //string | null | comment
    }

  };
  return ApiService(api);
};


export default moduleApi;
